export const TARGET_AGE = [
    {
        "value": "Under5",
        "label": "<5 year-old"
    },
    {
        "value": "5-7YO",
        "label": "5-7 year-old"
    },
    {
        "value": "8-9YO",
        "label": "8-9 year-old"
    },
    {
        "value": "10-12YO",
        "label": "10-12 year-old"
    },
    {
        "value": "13-14YO",
        "label": "13-14 year-old"
    },
    {
        "value": "15-18YO",
        "label": "15-18 year-old"
    },
    {
        "value": "19-24YO",
        "label": "19-24 year-old"
    },
    {
        "value": "25-34YO",
        "label": "25-34 year-old"
    },
    {
        "value": "35-44YO",
        "label": "35-44 year-old"
    },
    {
        "value": "45-54YO",
        "label": "45-54 year-old"
    },
    {
        "value": "55-64YO",
        "label": "55-64 year-old"
    },
    {
        "value": "Over65",
        "label": ">65 year-old"
    }
];

export const TARGET_AGE_MAP = {
    "Under5": {
        "label": "<5 year-old"
    },
    "5-7YO": {
        "label": "5-7 year-old"
    },
    "8-9YO": {
        "label": "8-9 year-old"
    },
    "10-12YO": {
        "label": "10-12 year-old"
    },
    "13-14YO": {
        "label": "13-14 year-old"
    },
    "15-18YO": {
        "label": "15-18 year-old"
    },
    "19-24YO": {
        "label": "19-24 year-old"
    },
    "25-34YO": {
        "label": "25-34 year-old"
    },
    "35-44YO": {
        "label": "35-44 year-old"
    },
    "45-54YO": {
        "label": "45-54 year-old"
    },
    "55-64YO": {
        "label": "55-64 year-old"
    },
    "Over65": {
        "label": ">65 year-old"
    }
};